function productSliderFade() {
  const slideWrapper = document.querySelector('.js-productSlideWrapper');
  const slides = document.querySelectorAll('.js-productSlide');
  const slideButtonNext = document.querySelector('.js-productSlideNext');
  const slideButtonPrev = document.querySelector('.js-productSlidePrev');
  const sliderThumbnails = document.querySelectorAll('.js-productSlideThumbnails');
  const thumbnailSlider = document.querySelector('.js-thumbnailSliderContainer');
  let currentSlide = -1;
  let startX = 0;
  let endX = 0;

  // activeSlideのindexをcurrentSlideに格納
  const activeSlide = document.querySelector('.js-productSlide.is-active');
  if (activeSlide) {
    currentSlide = Array.from(slides).indexOf(activeSlide);
  }

  // スライドボタン初期状態の設定
  updateButtons();

  // サムネイル初期状態の設定
  updateThumbnails();

  // スライダーの操作
  slideButtonNext.addEventListener('click', () => {
    changeSlide(currentSlide + 1);
  });

  slideButtonPrev.addEventListener('click', () => {
    changeSlide(currentSlide - 1);
  });

  function changeSlide(index) {
    slides[currentSlide].classList.remove('is-active');

    // スライドのインデックスを更新
    currentSlide = Math.max(0, Math.min(index, slides.length - 1));
    slides[currentSlide].classList.add('is-active');

    // サムネイルのスクロール位置を更新
    scrollThumbnailIntoView();

    // ボタンの状態を更新
    setTimeout(updateButtons, 200);

    // サムネイルの`aria-current`を更新
    updateThumbnails();
  }

  // タッチイベントの設定
  slideWrapper.addEventListener('touchstart', (e) => {
    startX = e.touches[0].clientX;
  });

  slideWrapper.addEventListener('touchmove', (e) => {
    endX = e.touches[0].clientX;
  });

  slideWrapper.addEventListener('touchend', () => {
    // スワイプの距離を計算
    const diffX = startX - endX;

    if (diffX > 50 && currentSlide < slides.length - 1) {
      changeSlide(currentSlide + 1);
    } else if (diffX < -50 && currentSlide > 0) {
      changeSlide(currentSlide - 1);
    }
  });

  // ボタンのdisabledを解除する処理
  function updateButtons() {
    slideButtonNext.disabled = (currentSlide === slides.length - 1);
    slideButtonPrev.disabled = (currentSlide === 0);
  }

  // サムネイルにaria-current=trueを付与する処理
  function updateThumbnails() {
    sliderThumbnails.forEach((thumbnail, index) => {
      if (index === currentSlide) {
        thumbnail.setAttribute('aria-current', 'true');
      } else {
        thumbnail.removeAttribute('aria-current');
      }
    });
  }

  // サムネイルの位置調整
  function scrollThumbnailIntoView() {
    const thumbnailsPerPage = 5;
    const totalThumbnails = sliderThumbnails.length;
  
    // currentSlideが4の倍数+1でない場合はスクロールを行わない
    if ((currentSlide + 1) % 4 !== 0 && currentSlide % 4 !== 0) {
      return;
    }
  
    let scrollPosition = Math.floor(currentSlide / 4) * 4;
  
    // 表示する範囲がサムネイルの総数を超えないように調整
    if (scrollPosition + thumbnailsPerPage > totalThumbnails) {
      scrollPosition = Math.max(0, totalThumbnails - thumbnailsPerPage);
    }
  
    // スクロール位置を設定
    const firstThumbnail = sliderThumbnails[scrollPosition];
    if (firstThumbnail) {
      const sliderRect = thumbnailSlider.getBoundingClientRect();
      const firstThumbnailRect = firstThumbnail.getBoundingClientRect();
      thumbnailSlider.scrollLeft += firstThumbnailRect.left - sliderRect.left;
    }
  }
}

window.addEventListener('DOMContentLoaded', productSliderFade);
